import { Timeline } from '@hopskipdrive/react-components';
import { colorPalette } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const RouteMapContainer = styled.div`
  display: contents;
`;

export const RATimelineNumberDot = styled(Timeline.NumberDot)`
  padding-left: 20px;

  & > div {
    background-color: ${colorPalette.green70} !important;
    border-color: ${colorPalette.green70} !important;
  }
`;

export const RATimelineLocationDot = styled(Timeline.LocationDot)`
  padding-left: 20px;

  svg {
    color: ${colorPalette.green70} !important;
  }
`;
